import {
    faComments,
    faComment,
    faPhone,
    faFax,
    faEnvelope,
} from '@fortawesome/free-solid-svg-icons';

const commentTypes = {
    email: {
        value: 'email',
        label: 'Email',
        icon: faEnvelope,
    },
    phone: {
        value: 'phone',
        label: 'Phone',
        icon: faPhone,
    },
    voicemail: {
        value: 'voicemail',
        label: 'Voicemail',
        icon: faFax,
    },
    chat: {
        value: 'chat',
        label: 'Chat',
        icon: faComments,
    },
    basic: {
        value: 'basic',
        label: 'Basic',
        icon: faComment,
    },
};

export default commentTypes;
